<template>
<v-text-field 
       :value="flexvalue"      
       v-model="flex"
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       v-on:click:clear="callClear()"
       v-on:input="updateData()">                                                    
    </v-text-field>
</template>

<script>
export default {
    watch: {
        flexvalue: {            
            handler(){
                this.updateData();
                this.saveFlexValue();
            } 
        },
        flexkey: {            
            handler(){
                this.getFlexValue();
            } 
        },        
    },
    props: {
        field: {
            type: String,
            default: ''
        },
        flextable: {
            type: String,
            required: true,
        },          
        flexkey: {
            type: String,
            required: true,
        },   
        flexfield: {
            type: String,
            required: true,
        },      
        flexvalue: {
            type: String,
            default:'',
        },
        label: {
            type: String,
            default: ''
        },             
        isClearable:{
            type: Boolean,
            default: false
        },
        isDense: {
            type: Boolean,
            init: true
        },
        localStorageItem:{
            type: String,
            default: ''
        }
    },    
    data() {
        return {
            flex: '',
        }
    },
    mounted() {
        this.getFlexValue();
    },
    methods: {
        callClear(){
            this.flex = '';
        },
        saveFlexValue(){            
            this.$axios
                .post("ares/json/ares/huis/flex/saveFlexValue.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveFlex"
                    },
                    params: {
                        flextable: this.flextable, // huis
                        flexkey: this.flexkey,  // huis-code maar dan de value
                        flexfield: this.flexfield, // old_airbnb_url of old_booking_url
                        flextype: 'char',
                        flexvalue: this.flexvalue
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', 'Error', res.data.error.message);
                    } else {
                        if(this.localStorageItem!=='' && res.data.flexvalue==='saved'){
                           localStorage.setItem(this.flexvalue);
                        } 
                    }
                })

        },
        getFlexValue() {
            this.$axios
                .post("ares/json/ares/huis/flex/getFlexValue.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getFlex"
                    },
                    params: {
                        flextable: this.flextable, // huis
                        flexkey: this.flexkey,  // huis-code maar dan de value
                        flexfield: this.flexfield, // old_airbnb_url of old_booking_url
                        flextype: 'char'
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', 'Error', res.data.error.message);
                    } else {
                        this.flex = res.data.flexvalue;
                        if(localStorage.getItem(this.localStorageItem)!==null){
                           this.flex=localStorage.getItem(this.localStorageItem).split(",");
                        } 
                        this.updateData();
                    }
                })
        },
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.flex })
        } 
    }
}
</script>

<style scoped>

</style>